<template>
  <Head title="Пусто" />
  <div>Для работы с ботом необходимо зарегистрироваться. Напишите любое сообщение в чате с ботом и получите инструкции как это сделать</div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
//
export default {

  mounted() {
    setTimeout(() => window.Telegram.WebApp.close(), 7000)
  },

  components: {
    Head,
  },
}
</script>
